function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Popover } from '../../../components/popover';
import { useDateState } from '../hooks/useDateState';
export function ViewCol(props) {
  var type = props.type,
      prefix = props.prefix,
      state = props.state,
      children = props.children,
      enableInvalidTooltip = props.enableInvalidTooltip,
      className = props.className,
      extra = _objectWithoutProperties(props, ["type", "prefix", "state", "children", "enableInvalidTooltip", "className"]);

  var colCls = classnames(usePrefixCls(prefix, _defineProperty({
    col: true
  }, type, true), true), useDateState(prefix, state), className);

  if (enableInvalidTooltip) {
    return React.createElement(Popover.HoverTrigger, Object.assign({
      className: colCls
    }, extra, {
      hideDelay: 0,
      showDelay: 150
    }), children);
  }

  return React.createElement("div", Object.assign({
    className: colCls
  }, extra), children);
}